import { FormattedMessage } from 'react-intl';

import config from '@/config';
import { hasWritePermission } from '@/utilities/permission';

import { ListItemType } from '../../constants';
import type { SecurityAuditAgeItem } from '../../types';
import { updatedAtLookup } from '../../utilities';
import { AgeIndicator } from '../AgeIndicator';
import { IgnoreIndicator } from '../IgnoreIndicator';
import { SecurityAuditGroupItem } from '../SecurityAuditGroupItem';
import { SecurityAuditItemRenderer, type SecurityAuditItemRendererProps } from '../SecurityAuditItemRenderer';
import { SecurityAuditSecretItem } from '../SecurityAuditSecretItem';

export interface SecurityAuditAgeItemRendererProps extends Omit<SecurityAuditItemRendererProps<SecurityAuditAgeItem>, 'children'> {}

export const SecurityAuditAgeItemRenderer = (props: SecurityAuditAgeItemRendererProps) => (
    <SecurityAuditItemRenderer<SecurityAuditAgeItem> {...props}>
        {({ item, isFirstGroup, isLastInGroup }) => {
            if (item.listItemType === ListItemType.GROUP) {
                return (
                    <SecurityAuditGroupItem
                        name={<FormattedMessage id={`password.age.${item.securityAge}`} />}
                        count={item.count}
                        isFirstGroup={isFirstGroup}
                    />
                );
            }

            const date = updatedAtLookup(item);
            const ignore = item.ignoreSecurityReport;

            return (
                <SecurityAuditSecretItem
                    id={item.id}
                    name={item.name}
                    canEdit={hasWritePermission(item.userPermissions)}
                    updateSecretRoute={config.routes.securityAuditAgeUpdateSecret}
                    isLastInGroup={isLastInGroup}
                    additional={
                        <>
                            {date ? <AgeIndicator date={date} /> : null}
                            {ignore ? <IgnoreIndicator /> : null}
                        </>
                    }
                />
            );
        }}
    </SecurityAuditItemRenderer>
);
